<template>
  <v-card :loading="isLoading">
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <h3>Data:</h3>
          <h4 class="font-weight-medium">
            {{ moment(this.evento.inizio).format("DD/MM/YYYY") }}
          </h4>
        </v-col>
        <v-col cols="12" sm="8" v-if="evento.cliente != null">
          <h3>Cliente:</h3>
          <h4 class="font-weight-medium">
            {{
              this.evento.cliente != null
                ? this.evento.cliente.descrizione
                : "---"
            }}
          </h4>
        </v-col>
        <v-col cols="12" sm="4">
          <h3>Giornata intera:</h3>
          <h4 class="font-weight-medium">
            {{ this.evento.giornoIntero ? "SI" : "NO" }}
          </h4>
        </v-col>
        <v-col cols="12" sm="4" v-if="!evento.giornoIntero">
          <h3>Ora Inizio:</h3>
          <h4 class="font-weight-medium">
            {{ moment(evento.inizio).format("HH:mm") }}
          </h4>
        </v-col>
        <v-col cols="12" sm="4" v-if="!evento.giornoIntero">
          <h3>Ora Fine:</h3>
          <h4 class="font-weight-medium">
            {{ moment(evento.fine).format("HH:mm") }}
          </h4>
        </v-col>
        <v-col cols="12" sm="8" v-if="evento.tipo != EventType.Assenza">
          <h3>Commessa:</h3>
          <h4 class="font-weight-medium">
            {{
              this.evento.commessa != null
                ? this.evento.commessa.descrizione
                : "---"
            }}
          </h4>
        </v-col>

        <v-col cols="12" v-if="evento.sede != null">
          <h3>Indirizzo:</h3>
          <h4 class="font-weight-medium" v-if="evento.sede != null">
            {{
              getFullAddress(
                this.evento.sede.indirizzo,
                this.evento.sede.citta,
                this.evento.sede.provincia
              )
            }}
          </h4>
        </v-col>
        <v-col cols="12" v-if="showMap && evento.sede != null">
          <Map 
            v-bind:indirizzo="this.evento.sede.indirizzo"
            v-bind:citta="this.evento.sede.citta"
          ></Map>
        </v-col>
        <v-col cols="12">
          <h3>Note:</h3>
          <h4 class="font-weight-medium">{{ this.evento.note }}</h4>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import EventType from "../../../settings/EventType";
import EasyPlanClient from "../../../utils/EasyPlanClient";
import Map from "../../CustomComponentsUI/Map";
export default {
  props: {
    evento: { type: Object, default: null },
  },
  components: { Map },
  mounted: function () {
    this.checkIfIsMobile()
    this.loadEventData(this.$props.evento);
  },
  data: () => ({
    isMobile:false,
    EventType: EventType,
    isLoading: false,
    moment: moment,
  }),
  watch: {
    evento(newVal) {
      this.loadEventData(newVal);
    },
  },
  methods: {
    
     checkIfIsMobile() {
      this.isMobile= window.innerWidth < 600;
    },
    getFullAddress(address, city, province) {
      let fullAddress = ""; //address + " - " + city + " (" + province + ") ";
      if (address != null) fullAddress += address;
      if (city != null) fullAddress += " - " + city;
      if (province != null) fullAddress += " (" + province + ")";

      return fullAddress;
    },
    async loadEventData(event) {
      this.isLoading = true;
      if (this.evento.cliente == null) {
        let customer = await this.loadCustomer(event.idCliente);
        this.evento.cliente = customer;
        this.refresh();
      }
      if (this.evento.sede == null) {
        let headquarter = await this.loadHeadquarter(event.idCliente,event.idSede);
        this.evento.sede = headquarter;
        this.refresh();
      } 
      if (this.evento.commessa == null) {
        let order = await this.loadOrder(event.idCommessa);
        this.evento.commessa = order;
        this.refresh();
      } 
      if (this.evento.creatore == null) {
        let creator = await this.loadUser(event.idCreatore);
        this.evento.creatore = creator;
        this.refresh();
      }
      this.isLoading = false;
    },
    refresh() {
      let ev = this.evento;
      this.evento = ev;
    },

    async loadHeadquarter(customerId,headquarterId) {
      let res = null;
      try {
        console.log("loading headquarter", headquarterId);
        res = await EasyPlanClient.Headquarters.Find(
          this.$route.params.companyAlias,
          customerId,
          headquarterId
        );

        console.debug("customer loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) { this.handleError(error);}
      return null;
    },
    async loadCustomer(customerId) {
      let res = null;
      try {
        console.log("loading customer", customerId);
        res = await EasyPlanClient.Customers.Find(
          this.$route.params.companyAlias,
          customerId
        );

        console.debug("customer loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) {this.handleError(error); }
      return null;
    }, 
    async loadOrder(orderId) {
      let res = null;
      try {
        console.log("loading order", orderId);
        res = await EasyPlanClient.Order.Find(
          this.$route.params.companyAlias,
          orderId
        );

        console.debug("order loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) {this.handleError(error); }
      return null;
    },
    
    async loadUser(userId) {
      let res = null;
      try {
        console.log("loading user", userId);
        res = await EasyPlanClient.User.Find(
          this.$route.params.companyAlias,
          userId
        );

        console.debug("user loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) {this.handleError(error); }
      return null;
    },
    handleError(error) {
      console.log(error);
      this.error = EasyPlanClient.GetErrorDescription(
        error.response.data.errorCode
      );
      console.error(
        "si è verificato un errore (" +
          error.response.data.errorCode +
          ")" +
          this.error
      );
    },
    //  loadCustomer(customerId, callback) {
    //   console.log("loading customer", customerId);
    //   EasyPlanClient.Customers.Find(this.$route.params.companyAlias, customerId)
    //     .then((res) => {
    //        console.debug("customer loaded",res);
    //       callback(res.data.data);
    //       // this.dialog = true;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.error = EasyPlanClient.GetErrorDescription(
    //         error.response.data.errorCode
    //       );
    //       console.error(
    //         "si è verificato un errore (" +
    //           error.response.data.errorCode +
    //           ")" +
    //           this.error
    //       );
    //       console.error(error);
    //     });
    // },
  },
  computed: {
    showMap() {
      if (this.evento.sede != null)
        return this.evento.sede.indirizzo != "" && this.evento.sede.citta != "";
      else return false;
    },
  },
};
</script>